import React, { useState } from 'react';
import { Field } from 'react-final-form';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { InfoTipForFields } from '../../components';
import css from './CountriesMultipleSelectField.module.css';
import classNames from 'classnames';

const CountriesMultipleSelectField = props => {
  const { label, name, id, options, placeholder, tipId, isRequired } = props;

  const CountriesMultipleSelectFieldComponent = ({
    input: { onChange, value },
    label,
    ...rest
  }) => {
    const initialValue = value
      ? value.map(v => {
          return {
            key: v,
            label: options.find(o => o.key === v)?.label,
          };
        })
      : [];
    const [countriesValue, setCountriesValue] = useState(initialValue);

    let notSelectedOptions = options.filter((o) => !initialValue.some(i => i.key === o.key));

    if(notSelectedOptions?.length === 1 && notSelectedOptions?.[0]?.key === 'all') {
      notSelectedOptions = []
    }
        
    return (
      <div className={css.fieldWrapper}>
        <p className={css.fieldLabel}>
          <span className={classNames({[css.isRequired]:isRequired})}>{label}</span>
          {tipId && <InfoTipForFields tipId={tipId} />}
        </p>
        <Autocomplete
          multiple
          id={id}
          options={notSelectedOptions}
          getOptionLabel={option => option.label}
          defaultValue={[]}
          renderInput={params => (
            <TextField {...params} variant="standard" placeholder={placeholder} />
          )}
          value={countriesValue}
          onChange={(event, newValue, reason) => {
            if (reason === 'selectOption' && !!newValue.find(item => item.key === "all")) {
              setCountriesValue(options.filter(item => item.key !== "all"));
              const convertedValues = options.filter(item => item.key !== "all").map(v => v.key);
              onChange(convertedValues);
            } else {
              setCountriesValue(newValue);
              const convertedValues = newValue.map(v => v.key);
              onChange(convertedValues);
            }
          }}
        />
      </div>
    );
  };
  return (
    <Field id={id} name={name} label={label} component={CountriesMultipleSelectFieldComponent} />
  );
};

export default CountriesMultipleSelectField;
